/* Nabtah — البحث الذكي */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var T = window.theme || {};
  var AR = '٠١٢٣٤٥٦٧٨٩';
  function ar(x) { x = String(x); return (T.money && T.money.arabic === false) ? x : x.replace(/[0-9]/g, function (d) { return AR[+d]; }); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function money(c) { return T.formatMoney ? T.formatMoney(c) : (c / 100) + ''; }

  /* ---------- تطبيع النص العربي ---------- */
  function norm(s) {
    return String(s || '').toLowerCase()
      .replace(/[ً-ٰٟـ]/g, '')          // تشكيل وتطويل
      .replace(/[أإآٱ]/g, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي').replace(/ؤ/g, 'و').replace(/ئ/g, 'ي')
      .replace(/[٠-٩]/g, function (d) { return AR.indexOf(d); })
      .replace(/[^\p{L}\p{N}\s]/gu, ' ').replace(/\s+/g, ' ').trim();
  }
  var PREFIX = /^(وال|بال|فال|كال|لل|ال)/;
  function stem(w) {
    if (w.length > 4) w = w.replace(PREFIX, '');
    if (w.length > 4) w = w.replace(/(ات|ين|ون|يه|ه)$/, '');
    return w;
  }
  function tokens(s) { return norm(s).split(' ').filter(function (w) { return w.length > 1; }); }

  /* ---------- مسافة التعديل (للأخطاء الإملائية) ---------- */
  function lev(a, b, max) {
    if (Math.abs(a.length - b.length) > max) return max + 1;
    var prev = [], cur, i, j;
    for (j = 0; j <= b.length; j++) prev[j] = j;
    for (i = 1; i <= a.length; i++) {
      cur = [i]; var rowMin = i;
      for (j = 1; j <= b.length; j++) {
        cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
        if (cur[j] < rowMin) rowMin = cur[j];
      }
      if (rowMin > max) return max + 1;
      prev = cur;
    }
    return prev[b.length];
  }
  function tol(w) { return w.length >= 7 ? 2 : w.length >= 4 ? 1 : 0; }

  /* ---------- البيانات ---------- */
  var root, cfg = {}, IDX = [], BY = {}, SYN = [], VOCAB = [];
  function load() {
    root = $('[data-ssearch]'); if (!root) return false;
    try { cfg = JSON.parse($('[data-ss-config]', root).textContent); } catch (e) { cfg = {}; }
    try { IDX = JSON.parse($('[data-ss-index]', root).textContent); } catch (e) { IDX = []; }
    IDX.forEach(function (p) {
      BY[p.h] = p;
      p.isB = /(^|\s)bundle(\s|$)/i.test(p.tg) || (p.b && p.b.length > 0);
      p.nt = norm(p.t); p.nn = norm(p.n); p.ng = norm(p.g + ' ' + p.ty + ' ' + p.tg); p.nd = norm(p.d + ' ' + (p['in'] || '')); p.ni = norm(p['in'] || '');
      p.words = tokens(p.t + ' ' + p.n + ' ' + p.g + ' ' + p.ty + ' ' + p.tg + ' ' + (p['in'] || '')).map(stem);
    });
    // المرادفات
    String(cfg.synonyms || '').split(/\n/).forEach(function (line) {
      var parts = line.split('=>'); if (parts.length < 2) return;
      var target = parts[1].trim(); if (!target) return;
      var words = parts[0].split(/[،,]/).map(function (w) { return stem(norm(w)); }).filter(Boolean);
      SYN.push({ words: words, target: target });
    });
    // قاموس الكلمات (للاقتراحات)
    var seen = {};
    IDX.forEach(function (p) { p.words.forEach(function (w) { if (w.length > 2 && !seen[w]) { seen[w] = 1; VOCAB.push(w); } }); });
    SYN.forEach(function (g) { g.words.forEach(function (w) { if (!seen[w]) { seen[w] = 1; VOCAB.push(w); } }); });
    return true;
  }

  function targetMatch(p, target) {
    if (target.charAt(0) === '#') { var tag = target.slice(1).toLowerCase(); return p.tg.toLowerCase().split(/\s+/).indexOf(tag) > -1 || (tag === 'bundle' && p.isB); }
    if (target.charAt(0) === '/') return p.u === target;
    return p.h === target || p.nn === norm(target);
  }

  /* ---------- البحث ---------- */
  function search(q) {
    var qt = tokens(q).map(stem); if (!qt.length) return { items: [], fixed: null, intent: null };
    var fixed = [], changed = false, synHits = [];
    // تصحيح الكلمات + المرادفات
    qt.forEach(function (w) {
      var best = w, bestD = 99;
      if (VOCAB.indexOf(w) === -1) {
        VOCAB.forEach(function (v) {
          if (v.indexOf(w) === 0 && w.length >= 2) { if (bestD > 0.5) { best = v; bestD = 0.5; } return; }
          var d = lev(w, v, tol(w)); if (d <= tol(w) && d < bestD) { best = v; bestD = d; }
        });
      }
      if (best !== w && bestD >= 1) changed = true;
      fixed.push(bestD >= 1 ? best : w);
      SYN.forEach(function (g) {
        g.words.forEach(function (sw) {
          if (sw === w || sw === best || (w.length >= 3 && sw.indexOf(w) === 0) || lev(w, sw, tol(sw)) <= tol(sw)) synHits.push(g.target);
        });
      });
    });
    var wantsBundle = synHits.some(function (t) { return t === '#bundle'; });
    var scored = IDX.map(function (p) {
      var s = 0;
      fixed.forEach(function (w, i) {
        var raw = qt[i];
        if (p.nt.indexOf(w) > -1 || p.nt.indexOf(raw) > -1) s += 12;
        else if (p.nn.indexOf(w) > -1) s += 9;
        else if (p.ng.indexOf(w) > -1) s += 5;
        else if (p.ni && p.ni.indexOf(w) > -1) s += p.isB ? 1 : 8;
        else if (p.nd.indexOf(w) > -1) s += 3;
        p.words.forEach(function (pw) {
          if (pw.indexOf(w) === 0) s += 4;
          else if (w.length >= 4 && lev(w, pw, tol(w)) <= tol(w)) s += 3;
        });
      });
      synHits.forEach(function (t) { if (targetMatch(p, t)) s += 14; });
      if (p.isB) s += wantsBundle ? 6 : -2;
      if (!p.a) s -= 4;
      return { p: p, s: s };
    }).filter(function (x) { return x.s > 0; }).sort(function (a, b) { return b.s - a.s; });
    var intent = null;
    synHits.forEach(function (t) { if (!intent && t.charAt(0) !== '#' && t.charAt(0) !== '/' && BY[t]) intent = BY[t]; });
    return { items: scored.map(function (x) { return x.p; }), fixed: changed ? fixed.join(' ') : null, intent: intent, wantsBundle: wantsBundle };
  }

  /* ---------- الرسم ---------- */
  function hl(text, q) {
    var t = esc(text), words = tokens(q).map(stem).filter(function (w) { return w.length > 1; });
    words.forEach(function (w) {
      // تمييز على النص الأصلي بمطابقة مرنة للهمزات
      var re = new RegExp('(' + w.split('').map(function (ch) {
        var m = { 'ا': '[اأإآ]', 'ه': '[هة]', 'ي': '[يى]' }[ch]; return m || ch.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
      }).join('[ً-ٟـ]*') + ')', 'gi');
      t = t.replace(re, '<mark>$1</mark>');
    });
    return t;
  }
  function stars(r) { var n = Math.round(+r || 0); if (!n) return ''; return '<span class="stars">' + '★★★★★'.slice(0, n) + '<span style="opacity:.3">' + '★★★★★'.slice(0, 5 - n) + '</span></span>'; }
  function row(p, q, i) {
    var badge = p.n && !p.isB ? '<span class="ss-r__need" style="--nc:' + esc(p.ac || '#B8923A') + '">' + esc(p.n) + '</span>' : (p.isB ? '<span class="ss-r__need ss-r__need--b">باقة توفير</span>' : '');
    var pct = p.c > p.p ? Math.round((p.c - p.p) / p.c * 100) : 0;
    return '<div class="ss-r" role="option" id="ssr' + i + '" data-ss-row>' +
      '<a class="ss-r__img" href="' + esc(p.u) + '" tabindex="-1">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : '') + (pct ? '<span class="ss-r__pct">-' + ar(pct) + '٪</span>' : '') + '</a>' +
      '<div class="ss-r__info"><a class="ss-r__t" href="' + esc(p.u) + '">' + hl(p.t, q) + '</a>' + badge +
      (p.g ? '<span class="ss-r__g">' + hl(p.g, q) + '</span>' : '') +
      (p['in'] && norm(p['in']).indexOf(stem(tokens(q)[0] || '~')) > -1 ? '<span class="ss-r__g">فيها: ' + hl(p['in'], q) + '</span>' : '') +
      '<div class="ss-r__meta"><b>' + esc(p.pf) + '</b>' + (p.cf ? '<s>' + esc(p.cf) + '</s>' : '') + (+p.r ? ' <span class="ss-r__rt">' + stars(p.r) + (p.rc ? ' <small>(' + ar(p.rc) + ')</small>' : '') + '</span>' : '') + '</div></div>' +
      '<div class="ss-r__act">' + (p.a ? (p.isB ? '<button type="button" class="ss-btn" data-add-variant="' + p.v + '" data-qty="1">' + esc(cfg.addText || 'أضيفي') + '</button>'
        : '<button type="button" class="ss-btn" data-quick-view="' + esc(p.u) + '">' + esc(cfg.offerText || 'اختاري العرض') + '</button><button type="button" class="ss-btn ss-btn--ghost" data-add-variant="' + p.v + '" data-qty="1" data-silent aria-label="' + esc(cfg.addText) + '">+</button>')
        : '<span class="ss-r__oos">نفدت</span>') + '</div></div>';
  }
  function mcard(p) {
    return '<div class="ss-mcard"><a href="' + esc(p.u) + '">' + (p.i ? '<img src="' + esc(p.i) + '" alt="" loading="lazy">' : '') + '</a><a class="ss-mcard__t" href="' + esc(p.u) + '">' + esc(p.t) + '</a>' +
      '<div class="ss-mcard__f"><b>' + esc(p.pf) + '</b>' + (p.a ? '<button type="button" class="ss-add" data-add-variant="' + p.v + '" data-qty="1" data-silent aria-label="أضيفي">+</button>' : '') + '</div></div>';
  }
  function bundleFor(p) {
    var best = null, bestSave = 0;
    IDX.forEach(function (b) {
      if (!b.isB || !b.a || !b.b || b.b.indexOf(p.h) === -1) return;
      var save = (b.c || 0) - b.p; if (save > bestSave || (!best && save >= 0)) { best = b; bestSave = save; }
    });
    return best;
  }

  var lastQ = '', active = -1, reqId = 0;
  function render(q) {
    var idle = $('[data-ss-idle]', root), live = $('[data-ss-live]', root);
    var clr = $('[data-ss-clear]', root); if (clr) clr.hidden = !q;
    if (!q.trim()) { idle.hidden = false; live.hidden = true; return; }
    idle.hidden = true; live.hidden = false; lastQ = q; active = -1;
    var r = search(q), items = r.items.slice(0, cfg.max || 6);
    // هل تقصدي
    var dym = $('[data-ss-dym]', root);
    dym.hidden = !r.fixed; if (r.fixed) dym.innerHTML = esc(cfg.dym) + ' <button type="button" data-ss-q="' + esc(r.fixed) + '">' + esc(r.fixed) + '</button>';
    // القسم المقصود
    var it = $('[data-ss-intent]', root);
    it.hidden = !r.intent;
    if (r.intent) it.innerHTML = '<a href="' + esc(r.intent.u) + '" style="--nc:' + esc(r.intent.ac || '#B8923A') + '"><i></i>' + esc(cfg.intent) + ' «' + esc(r.intent.n || r.intent.t) + '» ←</a>';
    // النتايج
    $('[data-ss-results]', root).innerHTML = items.map(function (p, i) { return row(p, q, i); }).join('');
    // أب سيل: الباقة اللي فيها أول منتج
    var up = $('[data-ss-upsell]', root); up.innerHTML = '';
    var top = items[0];
    if (cfg.upsell && top && !top.isB) {
      var b = bundleFor(top);
      if (b) {
        var save = Math.max(0, (b.c || 0) - b.p);
        var txt = String(cfg.upsellTpl || '').replace('[saving]', money(save)).replace('[bundle]', b.t);
        up.innerHTML = '<div class="ss-up"><img src="' + esc(b.i) + '" alt="" loading="lazy"><div class="ss-up__t"><span class="ss-up__tag">' + (save ? 'وفّري ' + ar(Math.round(save / (b.c || 1) * 100)) + '٪' : 'باقة') + '</span><b>' + esc(txt) + '</b><small>' + esc(b.pf) + (b.cf ? ' <s>' + esc(b.cf) + '</s>' : '') + '</small></div><button type="button" class="ss-btn" data-add-variant="' + b.v + '" data-qty="1">' + esc(cfg.addText) + '</button></div>';
      }
    }
    // كروس سيل: منتجات تانية مش في النتايج
    var cw = $('[data-ss-cross-wrap]', root), cr = $('[data-ss-cross]', root);
    if (cfg.cross && items.length) {
      var inRes = items.map(function (p) { return p.h; });
      var cross = IDX.filter(function (p) { return !p.isB && p.a && inRes.indexOf(p.h) === -1; }).slice(0, 3);
      cr.innerHTML = cross.map(mcard).join(''); cw.hidden = !cross.length;
    } else cw.hidden = true;
    // مفيش نتايج
    var em = $('[data-ss-empty]', root);
    em.hidden = items.length > 0;
    if (!items.length) {
      var best = IDX.filter(function (p) { return !p.isB && p.a; }).slice(0, 4);
      em.innerHTML = '<p>' + esc(String(cfg.empty || '').replace('[q]', q)) + '</p><div class="ss-mini">' + best.map(mcard).join('') + '</div>';
    }
    // كل النتايج
    var all = $('[data-ss-all]', root); all.hidden = false; all.textContent = cfg.all + ' «' + q + '» ←';
    // صفحات ومقالات من شوبيفاي
    var pw = $('[data-ss-pages-wrap]', root), pg = $('[data-ss-pages]', root);
    pw.hidden = true;
    var id = ++reqId;
    if (T.routes && T.routes.search && q.trim().length >= 2) {
      fetch(T.routes.search + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,page,article&resources[limit]=4&resources[options][fields]=title,product_type,variants.title,tag,body')
        .then(function (res) { return res.json(); }).then(function (j) {
          if (id !== reqId) return;
          var R = (j.resources && j.resources.results) || {};
          var extra = [];
          (R.collections || []).forEach(function (c) { extra.push({ t: c.title, u: c.url, k: 'قسم' }); });
          (R.pages || []).forEach(function (c) { extra.push({ t: c.title, u: c.url, k: 'صفحة' }); });
          (R.articles || []).forEach(function (c) { extra.push({ t: c.title, u: c.url, k: 'مقال' }); });
          pg.innerHTML = extra.slice(0, 5).map(function (x) { return '<a href="' + esc(x.u) + '"><small>' + x.k + '</small>' + hl(x.t, q) + '</a>'; }).join('');
          pw.hidden = !extra.length;
          // منتجات مش في الفهرس الفوري
          var have = {}; items.forEach(function (p) { have[p.u.split('?')[0]] = 1; });
          var more = (R.products || []).filter(function (p) { return !have[String(p.url).split('?')[0]] && !BY[p.handle]; });
          if (more.length) {
            var box = $('[data-ss-results]', root);
            box.insertAdjacentHTML('beforeend', more.slice(0, 3).map(function (p, k) {
              var pr = Math.round(parseFloat(p.price) * 100);
              return row({ h: p.handle, t: p.title, u: p.url, i: p.image, p: pr, c: 0, pf: money(pr), cf: '', n: p.product_type || '', g: '', tg: (p.tags || []).join(' '), v: p.variants && p.variants[0] && p.variants[0].id, a: p.available !== false, r: 0 }, q, items.length + k);
            }).join(''));
            em.hidden = true;
          }
        }).catch(function () {});
    }
  }

  /* ---------- آخر عمليات البحث / اتفرجتي عليها ---------- */
  function lsGet(k) { try { return JSON.parse(localStorage.getItem(k) || '[]'); } catch (e) { return []; } }
  function lsSet(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} }
  function saveRecent(q) { q = q.trim(); if (q.length < 2) return; var a = lsGet('nabtah-rs').filter(function (x) { return x !== q; }); a.unshift(q); lsSet('nabtah-rs', a.slice(0, 6)); }
  function paintIdle() {
    var rs = lsGet('nabtah-rs'), w = $('[data-ss-recent-wrap]', root);
    if (w) { w.hidden = !rs.length; $('[data-ss-recent]', root).innerHTML = rs.map(function (q) { return '<button type="button" class="ss-chip ss-chip--r" data-ss-q="' + esc(q) + '">' + esc(q) + '</button>'; }).join(''); }
    var rv = lsGet('nabtah-rv').map(function (h) { return BY[h]; }).filter(Boolean).slice(0, 4), vw = $('[data-ss-viewed-wrap]', root);
    if (vw) { vw.hidden = !rv.length; $('[data-ss-viewed]', root).innerHTML = rv.map(mcard).join(''); }
  }
  // تسجيل المنتج اللي اتفتح
  (function track() {
    var m = location.pathname.match(/\/products\/([^/?#]+)/); if (!m) return;
    var a = lsGet('nabtah-rv').filter(function (h) { return h !== m[1]; }); a.unshift(m[1]); lsSet('nabtah-rv', a.slice(0, 10));
  })();

  /* ---------- الأمثلة المتغيرة ---------- */
  var rotT;
  function rotate(inp) {
    var list = (inp.dataset.rotating || '').split(/<br\s*\/?>/).map(function (x) { return x.trim(); }).filter(Boolean);
    if (!list.length) return; var base = inp.getAttribute('placeholder'), i = 0;
    clearInterval(rotT);
    rotT = setInterval(function () { if (inp.value || document.activeElement !== inp) { inp.setAttribute('placeholder', base); return; } inp.setAttribute('placeholder', list[i++ % list.length]); }, 2600);
  }

  /* ---------- الفتح والقفل ---------- */
  function open() {
    if (!root && !load()) return;
    root.classList.add('is-open'); root.setAttribute('aria-hidden', 'false'); document.body.classList.add('lock');
    paintIdle();
    var inp = $('[data-search-input]', root); setTimeout(function () { inp.focus(); inp.select(); }, 60); rotate(inp);
    if (inp.value) render(inp.value);
  }
  function close() { if (!root) return; root.classList.remove('is-open'); root.setAttribute('aria-hidden', 'true'); document.body.classList.remove('lock'); clearInterval(rotT); }
  window.NabtahSearch = { open: open, close: close, search: function (q) { if (!root) load(); return search(q); }, render: function (q) { if (!root) load(); render(q); } };

  document.addEventListener('click', function (e) {
    var t = e.target, el;
    if (t.closest('[data-search-open]')) { e.preventDefault(); e.stopImmediatePropagation(); open(); return; }
    if (!root) return;
    if (t.closest('[data-search-close]') && root.contains(t)) { close(); return; }
    if ((el = t.closest('[data-ss-q]')) && root.contains(el)) { var inp = $('[data-search-input]', root); inp.value = el.dataset.ssQ; render(inp.value); saveRecent(inp.value); inp.focus(); return; }
    if (t.closest('[data-ss-clear]')) { var i2 = $('[data-search-input]', root); i2.value = ''; render(''); i2.focus(); return; }
    if (t.closest('[data-ss-recent-clear]')) { lsSet('nabtah-rs', []); paintIdle(); return; }
    if (root.contains(t) && t.closest('a[href]')) { saveRecent($('[data-search-input]', root).value); }
    if (root.contains(t) && t.closest('[data-quick-view]')) { saveRecent($('[data-search-input]', root).value); close(); }
  }, true);

  var debounce;
  document.addEventListener('input', function (e) {
    if (!root || !e.target.matches('[data-ssearch] [data-search-input]')) return;
    clearTimeout(debounce); var v = e.target.value; debounce = setTimeout(function () { render(v); }, 90);
  }, true);
  document.addEventListener('keydown', function (e) {
    if (!root || !root.classList.contains('is-open')) {
      if ((e.key === '/' || (e.key === 'k' && (e.metaKey || e.ctrlKey))) && !/INPUT|TEXTAREA|SELECT/.test((document.activeElement || {}).tagName || '')) { e.preventDefault(); open(); }
      return;
    }
    if (e.key === 'Escape') { close(); return; }
    var rows = $$('[data-ss-row]', root); if (!rows.length) return;
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault(); active = (active + (e.key === 'ArrowDown' ? 1 : -1) + rows.length) % rows.length;
      rows.forEach(function (r, i) { r.classList.toggle('is-active', i === active); });
      rows[active].scrollIntoView({ block: 'nearest' });
      $('[data-search-input]', root).setAttribute('aria-activedescendant', rows[active].id);
    } else if (e.key === 'Enter' && active > -1) {
      e.preventDefault(); saveRecent($('[data-search-input]', root).value); var a = $('.ss-r__t', rows[active]); if (a) location.href = a.href;
    }
  });
  document.addEventListener('submit', function (e) { if (root && e.target.matches('[data-ssearch-form]')) saveRecent($('[data-search-input]', root).value); }, true);

  /* ---------- البحث بالصوت ---------- */
  function initVoice() {
    var btn = root && $('[data-ss-voice]', root), SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!btn || !SR) return; btn.hidden = false;
    btn.addEventListener('click', function () {
      var rec = new SR(); rec.lang = 'ar-EG'; rec.interimResults = true; btn.classList.add('is-on');
      rec.onresult = function (ev) { var txt = Array.prototype.map.call(ev.results, function (r) { return r[0].transcript; }).join(' '); var inp = $('[data-search-input]', root); inp.value = txt; render(txt); };
      rec.onend = function () { btn.classList.remove('is-on'); saveRecent($('[data-search-input]', root).value); };
      rec.onerror = rec.onend; try { rec.start(); } catch (err) { btn.classList.remove('is-on'); }
    });
  }

  /* ---------- صفحة نتايج البحث: بديل ذكي لو مفيش نتايج ---------- */
  function initPageFallback() {
    var box = $('[data-smart-fallback]'); if (!box || !load()) return;
    var q = box.dataset.q || '', r = search(q), items = r.items.filter(function (p) { return p.a; }).slice(0, 8);
    if (!items.length) return;
    box.hidden = false;
    $('[data-smart-fallback-title]', box).textContent = (r.fixed ? cfg.dym + ' «' + r.fixed + '»' : 'ممكن يعجبك');
    $('[data-smart-fallback-list]', box).innerHTML = items.map(mcard).join('');
  }

  function boot() { if (load()) { initVoice(); initPageFallback(); } }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { if (e.target.querySelector && e.target.querySelector('[data-ssearch]')) { root = null; IDX = []; BY = {}; SYN = []; VOCAB = []; boot(); } });
})();
